/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tab/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import Icon from './Icon/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Tab({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs/Tab",
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let tabIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'id',
})
let globalTabIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'tab_id',
})
let tabItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'tab_item',
path: 'isLast',
})
let aggregateData = fromAggregate.equals(tabIdValueData, globalTabIdValueData, tabItemIsLastValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
})
let tabIdValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'id',
})
let globalTabIdValueData1 = fromData.useDataValue({ viewPath,
context: 'global',
path: 'tab_id',
})
let aggregateData1 = fromAggregate.equals(tabIdValueData1, globalTabIdValueData1)
let tabNameValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<button
  data-testid="Tab.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-2-mwf': hovered && selected ? dtColorsNeutral200 : hovered ? dtColorsNeutral200 : selected ? dtColorsNeutral200 : dtColorsWhite,'--mb-1-mwf': aggregateData ? "0px" : "8px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Tab.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Icon
  viewPath={`${viewPath}/Icon`}
 data="tab.id"
 data="global.tab_id"
 aggregate="/Simple/Data/aggregate.js equals"
 selected={selected}
 hovered={hovered}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 cursor="pointer"
 size="large"
 weight="semibold"
 marginLeft={4}
 marginRight={4}
 letterSpacing={0.1}
 color={dtColorsNeutral900}
 fontSize={dtTypographyFontsizeM}
 lineHeight="16px"
 data="tab.name"
 text={tabNameValueData}
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
 selected={selected}
/>
</button>
{children}
</React.Fragment>)
}